import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);

import navToggle from './nav';

const scroll2 = {
  scroll2: (element) => {
    const href = element.href ? element.href : element.firstElementChild.href;

    const url = new URL(href);

    if (
      location.pathname.replace(/^\//, '') == url.pathname.replace(/^\//, '')
      && 
      location.hostname == url.hostname
    ) {

      if (document.body.classList.contains('nav-open')) {
        navToggle.toggleNav();
      }

      const scroll2 = href.split('#')[1];

      if (scroll2) {

        const scroll22 = document.getElementById(scroll2);

        const offset = 60;

        gsap.to(window, {
          duration: 1.5,
          ease: 'power3.inOut',
          scrollTo: { 
            y: scroll22, 
            offsetY: offset
          },
        });
      } else {
        console.log('No scroll2');
      }
    }

  }, 
  scroll2Next: (link) => {

    const parentSection = link.closest('section');
    
    if (!parentSection) {
      console.log('The link is not inside a section.');
      return;
    }

    const nextSection = parentSection.nextElementSibling;

    if (nextSection) {

      const offset = 0;

      gsap.to(window, {
        duration: 2,
        ease: 'power3.inOut',
        scrollTo: {
          y: nextSection,
          offsetY: offset
        },
      });
    } else {
      console.log('No scroll2Next');
    }
  },
  scroll2Footer: () => {

    const footer = document.getElementById('footer');

    if (footer) {

      const offset = 0;

      gsap.to(window, {
        duration: 2,
        ease: 'power3.inOut',
        scrollTo: {
          y: footer,
          offsetY: offset
        },
      });
    } else {
      console.log('No scroll2Footer');
    }
  },
  init: () => {
    const nextSectionLinks = document.querySelectorAll('.scroll-to-next-section');

    nextSectionLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        scroll2.scroll2Next(link);
      });
    });

    const s2 = document.querySelectorAll('.scroll-to');
    if (s2.length > 0) {
      s2.forEach((link) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          scroll2.scroll2(link);
        });
      });
    }
  }
};

export default scroll2;
